import React, { useState } from 'react';
import format from 'date-fns/format';
import styled from 'styled-components';

import { formatDate } from '../../utils/constants';
import { getReportsByStartAndEndDateByProject } from '../../services/reportService';
import Loading from '../common/loading';
import QueryForm from './Components/QueryForm';
import QueryTable from './Components/QueryTable';

const initialState = {
  startDate: format(new Date(), formatDate.DATE),
  endDate: format(new Date(), formatDate.DATE),
  projectId: 'all',
};

const Query = () => {
  const [state, setState] = useState(initialState);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleDateChange = (date, name) => {
    const data = { ...state };
    data[name] = format(date, formatDate.DATE);
    setState(data);
  };

  const handleInputChange = ({ target: input }) => {
    const data = { ...state };
    data[input.name] = input.value;
    setState(data);
  };

  const populateReports = async () => {
    setIsLoading(true);
    const startDateFormated = format(new Date(state.startDate), 'yyyy-MM-dd');
    const endDateFormeted = format(new Date(state.endDate), 'yyyy-MM-dd');
    const { data } = await getReportsByStartAndEndDateByProject(
      startDateFormated,
      endDateFormeted,
      state.projectId
    );
    setReports(data);
    setIsLoading(false);
  };

  return (
    <QueryContainer>
      <Title>Consulta de informes</Title>
      <Loading open={isLoading} />
      <QueryForm
        data={state}
        onInputChange={handleInputChange}
        onDateChange={handleDateChange}
        onSubmit={populateReports}
        projectId={state.projectId}
      />
      <QueryTable data={reports} />
    </QueryContainer>
  );
};

const QueryContainer = styled.main`
  width: 100%;
  padding: 0 2em;
`;

const Title = styled.h1`
  width: 100%;
  text-align: center;
`;

export default Query;
